import { Icon, AiGenFillIcon } from '@design-systems/react-icons'
import { Card, Grid, Heading, Button } from '@design-systems/canvas-ui'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { InsightsTab } from '../utils'
import { getImagePathAndClass, determineSummaryDisplayDate } from './utils'
import './summary.scss'

interface SummaryProps {
    tab: InsightsTab
    title: string | null
    summary: string | null
    startDate?: string
    endDate?: string
    onClickSeeDetails?: () => void
    showSummaryDetailsButton?: boolean
}

export const Summary: React.FC<SummaryProps> = ({
    tab,
    title,
    summary,
    onClickSeeDetails,
    startDate,
    endDate,
    showSummaryDetailsButton = true,
}) => {
    const { insights } = TRANSLATION_KEYS
    const { t } = useEssentials()

    const hasData = !!(title && summary)
    const isYesterdayTab = tab === InsightsTab.Yesterday
    const { path, classnames } = getImagePathAndClass(tab, hasData)

    return (
        <Card
            className={`${classnames.card} ${classnames.font} card_container hc8-pt-6x`}
        >
            <Grid.Container
                align="start"
                direction="column"
                noWrap={false}
                spacing="normal"
                className="hc8-pa-none"
            >
                <Grid.Item className="hc8-ph-3x">
                    {`${t(isYesterdayTab ? insights.summaryForYesterday : insights.summaryForWeek)} 
                    ${determineSummaryDisplayDate(isYesterdayTab, startDate, endDate)}`}
                </Grid.Item>
                <Grid.Item className="hc8-ph-3x">
                    <Heading
                        size={3}
                        className={`${classnames.font} hc8-mv-1x`}
                    >
                        {hasData
                            ? title
                            : isYesterdayTab
                              ? t(insights.noDataTitleYesterday)
                              : t(insights.noDataTitleWeekly)}
                    </Heading>
                </Grid.Item>
                <Grid.Item className="hc8-ph-3x">
                    {hasData ? summary : t(insights.checkBackLater)}
                </Grid.Item>
                {showSummaryDetailsButton && hasData ? (
                    <Grid.Item className="hc8-ph-3x hc8-pt-1x">
                        <Button variant="secondary" onClick={onClickSeeDetails}>
                            <Icon
                                svg={AiGenFillIcon}
                                size="md"
                                className="hc8-mr-1x"
                            />
                            {t(insights.summaryDetails)}
                        </Button>
                    </Grid.Item>
                ) : null}
            </Grid.Container>
            {path && (
                <img
                    src={path}
                    alt=""
                    aria-hidden="true"
                    className="hc8-mt-4x summary-trailing-image"
                />
            )}
        </Card>
    )
}
